query AnalyticsUsersByDate(
  $filter: AnalyticsUsersFilterInput!
  $calendarInterval: CalendarInterval
) {
  analyticsUsers(filter: $filter) {
    usersByDate(calendarInterval: $calendarInterval) {
      calendarInterval
      items {
        label
        displayCurrency
        data {
          x
          y
        }
      }
    }
  }
}
